/* global document */
(function () {
  'use strict';

  class SnapshotLinkCtrl {
    constructor(Authenticator, ServiceVfiltro, $window, UrlConfigService, HttpServiceV3g, $httpParamSerializer, FeatureOuService, CadastroVeiculoService, $attrs) {
      this.authenticator = Authenticator;
      this.seePhotoLinkElement = null;
      this.window = $window;
      this.urlConfigService = UrlConfigService;
      this.httpService = HttpServiceV3g;
      this.httpParamSerializer = $httpParamSerializer;
      this.featureOuService = FeatureOuService;
      this.cadastroVeiculoService = CadastroVeiculoService;
      this.attrs = $attrs;

      this.uoId = angular.fromJson(this.window.localStorage.getItem(`vfiltro-${ServiceVfiltro.factoryVfiltro.user.id}`)).uo;
    }

    $postLink() {
      this.seePhotoLinkElement = document.createElement('vfleets-see-photo'); // eslint-disable-line
      this.buildSeePhotoLinkElement();
    }

    $onChanges(changes) {
      if (!this.seePhotoLinkElement) {
        return;
      }
      if (changes.uoWithRecFacial) {
        this.seePhotoLinkElement.uoWithRecFacial = !!this.uoWithRecFacial;
      }
      if (changes.isNa) {
        this.seePhotoLinkElement.isNa = !!this.isNa;
      }
    }

    /**
     * Necessário a utilização do $doCheck pois a div do template não era encontrado
     * na DOM na inicialização do component, fazendo com que o querySelector viesse
     * sempre null. Por isso foi criado condicionais para que depois que se encontre
     * uma vez o elemento na DOM não precisar mais buscar, para evitar o excesso de processamento
     * devido ao $doCheck que ocorre a cada modificação existente.
     */
    $doCheck() {
      const seePhotoLinkContainer = document.querySelector(`#${this.prefixContainer}-${this.alertId ? this.alertId : this.idSnapshot}`); // eslint-disable-line
      if (seePhotoLinkContainer && this.seePhotoLinkElement && seePhotoLinkContainer.innerHTML === '') {
        seePhotoLinkContainer.appendChild(this.seePhotoLinkElement);
      }
    }

    buildViewParams() {
      const params = {
        s3key: this.s3key,
        uoVeiculo: this.uoVeiculo
      };
      if (this.isFilled(this.bucket)) {
        params.bucket = this.bucket;
      }
      if (this.isFilled(this.bucketRegion)) {
        params.bucketRegion = this.bucketRegion;
      }
      return params;
    }

    isFilled(value) {
      return !!value && value !== 'undefined' && value !== 'null';
    }

    buildSeePhotoLinkElement() {
      const params = this.httpParamSerializer(this.buildViewParams());
      this.seePhotoLinkElement.isWithVigenciaManual = this.showOptionVigenciaManual();
      this.seePhotoLinkElement.hasPermissionEditMotorista = this.hasPermissionEditMotorista();
      this.seePhotoLinkElement.imageUrl = `/motorista/reconhecimento-facial/v2/view?${params}`;
      this.seePhotoLinkElement.snapshotId = this.idSnapshot;
      this.seePhotoLinkElement.hasPermissionViewVideo = this.hasPermissionViewVideo();
      this.seePhotoLinkElement.ignitionsVehicle = this.buildIgnitionsVehicle();
      this.seePhotoLinkElement.vigenciaAtual = this.vigenciaAtual ? this.vigenciaAtual : this.buildVigenciaPopUp();
      this.seePhotoLinkElement.uoId = this.uoId;
      this.seePhotoLinkElement.customButtonText = this.textButton;
      this.seePhotoLinkElement.isAlert = !!this.alertId;
      if (this.attrs && 'isNa' in this.attrs) {
        this.seePhotoLinkElement.isNa = !!this.isNa;
      } else {
        this.seePhotoLinkElement.isNa = false;
        this.featureOuService.getVehicleTableConfig(this.uoId)
          .then(isNaUo => {
            this.seePhotoLinkElement.isNa = isNaUo;
          })
          .catch(() => {});
      }
      if (this.attrs && 'uoWithRecFacial' in this.attrs) {
        this.seePhotoLinkElement.uoWithRecFacial = !!this.uoWithRecFacial;
      } else {
        this.seePhotoLinkElement.uoWithRecFacial = false;
        this.cadastroVeiculoService.hasRecFacial(this.uoId, null)
          .then(uoWithRecFacial => {
            this.seePhotoLinkElement.uoWithRecFacial = uoWithRecFacial;
          })
          .catch(() => {});
      }
      this.seePhotoLinkElement.addEventListener('vigenciaManualCadastrada', e => {
        if (e.detail.reload) {
          if (this.isHistoricoDetalhado) {
            this.window.location.reload();
          } else {
            this.onCloseDialog();
          }
        }
      });
    }

    buildVigenciaPopUp() {
      return angular.fromJson(this.vigenciaAtualPopup);
    }

    showOptionVigenciaManual() {
      return this.podeAbrirVigenciaManual;
    }

    buildIgnitionsVehicle() {
      return {
        veiculoId: this.idVeiculo,
        dateIgnitionOn: this.dateIgnitionOn,
        dateIgnitionOff: this.dateIgnitionOff
      };
    }

    getUrl() {
      return `${this.urlConfigService.getApiGatewayUrl()}/motorista/reconhecimento-facial/view/${this.idSnapshot}?datetimeReferencia=${this.dateIgnitionOn}`;
    }

    hasPermissionViewVideo() {
      return this.authenticator.hasRole('VIDEO_VISUALIZAR');
    }

    hasPermissionEditMotorista() {
      return this.authenticator.hasRole('MOTORISTA_EDITAR');
    }
  }

  angular
    .module('videoPlayer')
    .controller('SnapshotLinkCtrl', SnapshotLinkCtrl)
    .component('snapshotLink', {
      template: `<div id='{{$ctrl.prefixContainer}}-{{$ctrl.alertId ? $ctrl.alertId : $ctrl.idSnapshot}}'></div>`,
      controller: 'SnapshotLinkCtrl',
      bindings: {
        idSnapshot: '@',
        s3key: '@',
        bucket: '@',
        bucketRegion: '@',
        prefixContainer: '@',
        dateIgnitionOn: '@',
        dateIgnitionOff: '@',
        podeAbrirVigenciaManual: '<',
        vigenciaAtual: '<',
        vigenciaAtualPopup: '@',
        idVeiculo: '@',
        uoVeiculo: '@',
        textButton: '@',
        alertId: '@',
        uoWithRecFacial: '<',
        isNa: '<',
        onCloseDialog: '&'
      }
    });
}());
